
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlGetMailContentRequest } from "../models/service-models/mail/GetMailContentRequest";
import { mdlGetMailContentResponse } from "../models/service-models/mail/GetMailContentResponse";
import { GetResponse } from "../utils/ApiClient";

namespace MailService {
    export async function GetMailContent(
        pRequest: mdlGetMailContentRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<mdlGetMailContentResponse>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<mdlGetMailContentResponse>>>(
            "mail/get-mail-content",
            pRequest
        );
    }

}
export { MailService };